export default "__VITE_ASSET__0b2a2675__"